export default __webpack_public_path__ + "static/media/type5.c906119b.png";